import { signal } from '@angular/core';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { AuiStyleType } from './button';
import { AuiColor } from './color';
import { AuiSizeType } from './size';

type AuiItemConfig = {
    size: AuiSizeType;
    color: AuiColor;
    auiStyle: AuiStyleType;
    rounded: 'rounded-full' | 'rounded-none' | 'rounded' | 'no-border';
};

const AuiItemConfigDefault: AuiItemConfig = {
    size: '32',
    color: 'gray',
    auiStyle: 'solid',
    rounded: 'rounded',
};

export const [injectAuiItemConfig, provideAuiItemConfig] = createInjectionToken(() => {
    // const parentConfig = injectAuiItemConfig({ optional: true, skipSelf: true });
    const parentConfig = AuiItemConfigDefault;

    return {
        size: signal(parentConfig.size ?? AuiItemConfigDefault.size),
        color: signal(parentConfig.color ?? AuiItemConfigDefault.color),
        auiStyle: signal(parentConfig.auiStyle ?? AuiItemConfigDefault.auiStyle),
        rounded: signal(parentConfig.rounded ?? AuiItemConfigDefault.rounded),
    };
}, {});
